<div
  class="bg-primary-500 flex h-14 shrink-0 items-center border-b border-solid border-slate-300 text-white"
>
  <h3 class="!m-0 flex grow px-4 font-bold">Management Tools</h3>
  <button type="button" mat-icon-button (click)="closePanel.emit()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div class="min-h-0 flex-1 overflow-y-auto">
  @for (group of resourceGroups$ | async; track $index) {
    <div>
      @if (group.resource) {
        <div class="bg-primary-50 flex flex-row items-center gap-2 px-2 py-4">
          <div class="bg-primary-500 flex shrink-0 items-center justify-center rounded-full p-1">
          <mat-icon
            fontSet="material-symbols-outlined"
            class="icon-sm text-white"
            >{{ group.resource.resource.icon }}</mat-icon
          >
          </div>
          <div class="flex grow flex-col">
            <span class="text-[10px] uppercase leading-none text-slate-500">{{
              group.resource.resource.label
            }}</span>
            <span class="truncate text-sm font-bold text-slate-900">{{
              group.resolvedLabel$ | async
            }}</span>
          </div>
        </div>
      }
      <div class="flex flex-col">
        @for (item of group.tools; track item.tool.name) {
          @let disabled = item.disabled$ | async;
          <button
            class="group flex flex-row items-start gap-2 rounded border-none bg-transparent p-2 text-left"
            matTooltip="Not available"
            [matTooltipDisabled]="disabled === false"
            [ngClass]="{
              '!cursor-default opacity-50': disabled,
              'hover:text-primary-500 cursor-pointer hover:bg-slate-50':
                disabled === false
            }"
            (click)="disabled === false && runTool(item)"
          >
            <mat-icon
              fontSet="material-symbols-outlined"
              class="icon-sm mt-2 shrink-0 text-slate-500"
              >{{ item.tool.icon }}</mat-icon
            >
            <div class="flex grow flex-col">
              <div class="text-sm text-slate-900 group-hover:font-bold">
                {{ item.tool.label }}
              </div>
              @if (item.tool.description) {
                <div class="text-xs text-slate-500">
                  {{ item.tool.description }}
                </div>
              }
            </div>
          </button>
        }
      </div>
    </div>
  } @empty {
    <div
      class="flex flex-col items-center justify-center px-4 py-12 text-slate-500"
    >
      <mat-icon fontSet="material-symbols-outlined" class="icon-sm"
        >construction</mat-icon
      >
      <p class="m-0 text-xs">No tools available</p>
    </div>
  }
</div>

<div
  class="flex items-center justify-between border-t border-solid border-slate-200 px-4 py-2"
>
  <div class="flex flex-col">
    <span class="text-sm font-medium text-slate-700">Marketing Mode</span>
    <span class="text-xs text-slate-400">Mask PII with fake names</span>
  </div>
  <mat-slide-toggle
    [checked]="sidebar.obfuscateNames$ | async"
    (change)="sidebar.toggleObfuscateNames()"
  />
</div>
